import { SpeedUnit, speedConversion } from '@cas/utils/numberHelpers';
import { useLocaleFormatter } from '@customer/shared/hooks/useLocaleFormatter';
import { MeasurementUnit } from '@customer/store/apis/authApi';
import { useAppSelector } from '@customer/store/hooks';
import { useTranslation } from 'react-i18next';

export function SpeedRangeRenderer({ value }: { value: [number, number] }): string {
  const { t } = useTranslation();
  const { getNumberText } = useLocaleFormatter();
  const units = useAppSelector(state => state.auth.units);

  if (units === MeasurementUnit.Metric) {
    const minSpeed = speedConversion(value[0], SpeedUnit.mps, SpeedUnit.kmph);
    const maxSpeed = speedConversion(value[1], SpeedUnit.mps, SpeedUnit.kmph);

    return t('speedRange.kmph', {
      min: getNumberText(minSpeed, 1),
      max: getNumberText(maxSpeed, 1),
    });
  } else {
    const minSpeed = speedConversion(value[0], SpeedUnit.mps, SpeedUnit.mph);
    const maxSpeed = speedConversion(value[1], SpeedUnit.mps, SpeedUnit.mph);

    return t('speedRange.mph', {
      min: getNumberText(minSpeed, 1),
      max: getNumberText(maxSpeed, 1),
    });
  }
}

export default SpeedRangeRenderer;
